import { LoadingStatusType, Locales } from "@/enums/enums";
import { FilterAccountOfTransaction } from "@/helper/accountHelper";
import { i18n } from "@/i18n";
import { accountModal } from "@/model/type";
import facade from "@/service/account/accountFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Account extends VuexModule {
  public accountList: Array<accountModal> = [];
  public accountListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  @Mutation
  public MutationAccountList(accountList: Array<accountModal>) {
    this.accountList = accountList;
  }

  @Mutation
  public SetAccountListLoadingStatus(status: LoadingStatusType) {
    this.accountListLoadingStatus = status;
  }

  @Action
  public DoGetAllMainAccount() {
    if (this.accountListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Loading);
      API.AccountService.DoGetAllMainAccount().then((resAllMainAccount) => {
        if (resAllMainAccount.data.responseCode.IsSuccess()) {
          const accountList = facade.ToAccountList(resAllMainAccount.data.accountList, i18n.locale as Locales);
          this.context.commit("MutationAccountList", accountList);
        }
        this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  get getAllAccountList(): Array<accountModal> {
    return this.accountList;
  }

  get getAccountList(): Array<accountModal> {
    return FilterAccountOfTransaction(this.accountList);
  }
  get getAccountListLoadingStatus(): LoadingStatusType {
    return this.accountListLoadingStatus;
  }
}
